import { isJson } from '../_helpers';



export const cardsService = {
    getCardfromSessionStorage,
    searchCard
};


function getCardfromSessionStorage() {
    let myCardString = sessionStorage.getItem('card');
    let cardObject = {};
    try {
        cardObject = JSON.parse(myCardString);       
      
    } catch (e) {
        cardObject = { CARD_ID: '' };
    }
    return cardObject;
}

function searchCard(searchParam) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', },
        body: JSON.stringify(searchParam)
    };

    console.log(process.env.REACT_APP_REST_URL);
    return fetch(`${process.env.REACT_APP_REST_URL}/cards/search`, requestOptions)
        .then(handleResponse)
        .then(cardObject => {
            // login successful if there's a cardObject in the response
            if (cardObject) {
                sessionStorage.setItem('card', JSON.stringify(cardObject));
            }

            return cardObject;
        })
        .catch((err) => {
            console.log(err);
            sessionStorage.setItem('card', { });
            return { "error": true, "message": err };
        });

}

function handleResponse(response) {
    return response.text().then(text => {
        const data = isJson(text) ? JSON.parse(text) : { message: response.statusText };
        if (response.ok) {
            console.log(data);
            return data;
        } else {
            console.log(`-------- ${text} --------`);
            //const error = (data && data.message) || response.statusText;
            return Promise.reject(data.message);
        }
    });
}